const firebaseConfig = {
    apiKey: "AIzaSyCusAaLkqs_cv3QWgr69KKMvEwVkJBi0lE",
    authDomain: "agency-631e6.firebaseapp.com",
    databaseURL: "https://agency-631e6.firebaseio.com",
    projectId: "agency-631e6",
    storageBucket: "agency-631e6.appspot.com",
    messagingSenderId: "438991206980",
    appId: "1:438991206980:web:035365ca0b2d905d49da11"
  };
  
  export default firebaseConfig